import { Link } from 'react-router-dom';
import { useState } from 'react';

function SideNav({ theme, toggleTheme }) {

    const [showSubMenu, setShowSubMenu] = useState(true);
    const [sideNavIsOpen, setSideNavIsOpen] = useState(true);
    const [activePage, setActivePage] = useState('home');

    function toggleSubMenu() {
        if (!sideNavIsOpen && !showSubMenu) {
            setSideNavIsOpen(true);
        }
        setShowSubMenu(!showSubMenu);
    };

    function toggleSideNavIsOpen() {
        if (sideNavIsOpen && showSubMenu) {
            toggleSubMenu();
        }

        if (!sideNavIsOpen && !showSubMenu) {
            toggleSubMenu();
        }
        setSideNavIsOpen(!sideNavIsOpen);
    }

    function setActive(page) {
        setActivePage(page);
    }

    return (
        <nav id='side-nav-container' className={sideNavIsOpen ? '' : 'close'}>
            <ul>
                <li>
                    <span className="logo"><img alt='blackbird66 logo' className='logo' src="/assets/logo.svg" ></img></span>
                    <button id="toggle-btn" onClick={() => { toggleSideNavIsOpen() }}
                        className={sideNavIsOpen ? '' : 'rotate'}>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M440-240 200-480l240-240 56 56-183 184 183 184-56 56Zm264 0L464-480l240-240 56 56-183 184 183 184-56 56Z" /></svg>
                    </button>
                </li>

                <li className={activePage === 'home' ? 'active': ''}>
                    <Link to="/"
                        onClick={() => { toggleSubMenu(); setActive('home'); }}
                        className={showSubMenu ? 'dropdown-btn rotate' : 'dropdown-btn'}
                        id="toggle-btn">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z" /></svg>
                        <span>Home</span>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" /></svg>
                    </Link>
                    <ul className={showSubMenu ? 'sub-menu show' : 'sub-menu'}>
                        <div>
                            <li><a href="/#intro">Intro</a></li>
                            <li><a href="/#vehicle-formula">Formula</a></li>
                            <li><a href="/#the-car">Car</a></li>
                            <li><a href="/#next-steps">Next</a></li>
                        </div>
                    </ul>
                </li>

                <li className={activePage === 'gallery' ? 'active': ''}>
                    <Link to="/gallery"
                    onClick={() => {setActive('gallery')}}>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm40-80h480L570-480 450-320l-90-120-120 160Zm-40 80v-560 560Zm140-360q25 0 42.5-17.5T400-620q0-25-17.5-42.5T340-680q-25 0-42.5 17.5T280-620q0 25 17.5 42.5T340-560Z" /></svg>
                        <span>Gallery</span></Link>
                </li>
                <li className={activePage === 'about' ? 'active': ''}>
                    <Link to="/about"
                    onClick={() => {setActive('about')}}>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" /></svg>
                        <span>About</span></Link>
                </li>
                <li className={activePage === 'contact' ? 'active': ''}>
                    <Link to="/contact"
                    onClick={() => {setActive('contact')}}>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z" /></svg>
                        <span>Contact</span></Link>
                </li>
                <hr></hr>
                <li>
                    <button
                        className="theme"
                        onClick={() => { toggleTheme() }}
                    >
                        {theme === 'dark' ?
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M480-360q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Zm0 80q-83 0-141.5-58.5T280-480q0-83 58.5-141.5T480-680q83 0 141.5 58.5T680-480q0 83-58.5 141.5T480-280ZM200-440H40v-80h160v80Zm720 0H760v-80h160v80ZM440-760v-160h80v160h-80Zm0 720v-160h80v160h-80ZM256-650l-101-97 57-59 96 100-52 56Zm492 496-97-101 53-55 101 97-57 59Zm-98-550 97-101 59 57-100 96-56-52ZM154-212l101-97 55 53-97 101-59-57Zm326-268Z" /></svg>
                            : <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M480-120q-150 0-255-105T120-480q0-150 105-255t255-105q14 0 27.5 1t26.5 3q-41 29-65.5 75.5T444-660q0 90 63 153t153 63q55 0 101-24.5t75-65.5q2 13 3 26.5t1 27.5q0 150-105 255T480-120Zm0-80q88 0 158-48.5T740-375q-20 5-40 8t-40 3q-123 0-209.5-86.5T364-660q0-20 3-40t8-40q-78 32-126.5 102T200-480q0 116 82 198t198 82Zm-10-270Z" /></svg>
                        }
                        <span>{theme === 'dark' ? 'Light' : 'Dark'} Mode</span>
                    </button>
                </li>
            </ul>
        </nav>
    )
}

export default SideNav
